import './chatbot-message-active-tool-call.css';
import { ChatbotMessage } from './types';

interface ChatbotMessageActiveReasoningProps {
  message: ChatbotMessage;
}

export function ChatbotMessageActiveReasoning({ message }: ChatbotMessageActiveReasoningProps) {
  let reasoning = message?.activeReasoning?.content;
  if (reasoning) {
    reasoning = reasoning.replace(/\.+$/g, ''); // Remove dots at the end
  }

  return (
    <div className="chatbot-message-active-tool-call-masked-text">
      <span>{reasoning}</span>
      <div className="chatbot-message-active-tool-call-loading-dots mt-[3px]"></div>
    </div>
  );
}
